import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {DocumentService} from "../../../../shared/services/document.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {LeaveApplication} from "../../../../shared/interface/employee";
import {OfwcaMeeting} from "../../../../shared/interface/ofwca-meeting";
import {LeaveApplicationService} from "../../../../shared/services/leave-application.service";
import {FormBuilder, FormControl} from "@angular/forms";

@Component({
  selector: 'app-leave-application-list',
  templateUrl: './leave-application-list.component.html',
  styleUrls: ['./leave-application-list.component.scss']
})
export class LeaveApplicationListComponent implements OnInit,  OnDestroy, AfterViewInit  {
  @Input() LeaveApplication: Observable<LeaveApplication[]>;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  leaveApplicationDataSource: MatTableDataSource<LeaveApplication> = new MatTableDataSource<LeaveApplication>([]);
  displayedColumns: string[] = ['createdAt', 'acceptanceAt', 'type', 'status', 'start', 'day', 'time', 'actions'];
  userPermissions: ReplaySubject<UserPermissions>;
  leaveApplicationViewControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private documentService: DocumentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private leaveApplicationService: LeaveApplicationService
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.LeaveApplication
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((leaveApplication: LeaveApplication[]) => this.leaveApplicationDataSource.data = leaveApplication);

  }

  ngAfterViewInit(): void {
    this.leaveApplicationDataSource.paginator = this.paginator;
  }

  downloadPdf(leaveApplication: LeaveApplication): void {
    this.leaveApplicationService.downloadCertificate(leaveApplication.uuid);
  }

}
